<template>
  <div
    :class="['page_header--notifications--icon', {'has-items': unreadNotificationsCount}]"
    @click="openNotificationsModal"
  >
    <icon-default icon="notifications"></icon-default>
    <badge-default
      v-if="unreadNotificationsCount"
      class="page_header--notifications--badge"
      :count="unreadNotificationsCount"
    ></badge-default>
  </div>
</template>

<script>
export default {
  name: 'PageHeaderNotifications',
  computed: {
    unreadNotificationsCount() {
      return this.$store.getters.notificationsCount;
    },
  },
  methods: {
    openNotificationsModal() {
      this.$router.replace({query: {modal: 'notifications'}})
    },
  },
}
</script>

<style lang="scss" scoped>
@import "../../../styles/variables/variables";

.page_header--notifications {

  &--icon {
    position: relative;
    margin-right: 10px;
    color: $text-light;
    cursor: pointer;

    &.has-items {
      margin-right: 25px;
      color: $secondary
    }

    &:hover {
      color: $secondary;
    }
  }

  &--badge {
    position: absolute;
    left: 85%;
    top: 0;
  }
}
</style>
